<template>
  <div id="appbox">
    <div class="top_heard">
      <div class="top_box" v-if="screenWidth>785">
        <div class="logo_box" @click="gohome()">
          <img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;" height="" srcset="">
        </div>
        <div class="top_gatebox">
          <div class="manage_switch" v-if="screenWidth>785">
            <el-select v-model="manage_url" @change="manageurl" size="small" class="Site_switch_type"
                       placeholder="选择入口">
              <el-option
                  v-for="item in manageoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="top_search_box" v-if="screenWidth>785">
          <div class="top_search">
            <el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"

              >
              </el-option>
            </el-select>
            <!-- <i class="el-icon-search"></i> -->
            <input type="text" v-model="stitle" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"
                   style="border: 0px;width: 200px;height: 30px;">
            <img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" @click="gotopsearch()" alt=""
                 srcset="">
          </div>

        </div>
        <div class="top_right">
          <div class="top_Mobiletype" @click="goregister()">
            账号注册/绑定
          </div>
          <div class="" v-if="token">
            欢迎访问!
          </div>
          <div class="" v-if="token" style="color: darkred;margin-left: 5px;" @click="logout()">
            登出
          </div>
        </div>
      </div>
      <div class="top_tab_box">
        <van-nav-bar title="" style="color: #ffffff ;font-weight: 600;" @click-right="vannavshow=true"
                     v-if="screenWidth<785">
          <template #left>
            <div class="vannav_title" style="color: #217495;font-size: 16px;">
              课程详情
            </div>
          </template>
          <template #title>
            <div class="vannav_title" style="width: 180px;padding: 20px;">
              <img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;" height="" srcset="">
            </div>
          </template>
          <template #right>
            <van-icon name="ellipsis" size="20"/>
          </template>
        </van-nav-bar>
        <van-popup v-model="vannavshow" :style="{ height: '50%' }" position="top">
          <van-picker
              title=""
              show-toolbar
              :columns="vannavlist"
              confirm-button-text="进入"
              @confirm="vanlinkgo"
              @cancel="vannavmenushow"
              @change="onChange"
          />
        </van-popup>
        <div class="toptabnav" v-if="screenWidth>785">
          <el-menu
              :default-active="activeIndex2"
              class="el-menu-demo"
              mode="horizontal"
              @select="handleSelect"
              router
              background-color="#1b9d57"
              text-color="#FFFFFF"
              active-text-color="#FFFFFF">
            <el-menu-item index="/Home">首页</el-menu-item>
            <el-menu-item index="/Newslist">研学资讯</el-menu-item>
            <el-menu-item index="/Courselist">研学课程</el-menu-item>
            <el-submenu index="/institution">
              <template slot="title">研学单位</template>
              <el-menu-item index="/Camplist">研学营地</el-menu-item>
              <el-menu-item index="/Baselist">研学基地</el-menu-item>
              <el-menu-item index="/traveler">研学机构</el-menu-item>
            </el-submenu>

            <el-menu-item index="/Campmap">研学地图</el-menu-item>
<!--            <el-menu-item index="/Activitylist">活动中心</el-menu-item>-->
            <el-submenu index="/Mentorlist">
						    <template slot="title">证书管理</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/Mentorlist" >导师证书查询</el-menu-item>
						   
						  </el-submenu>
            <el-menu-item index="/Linelist">研学线路</el-menu-item>
            <el-submenu index="/yanxueteam">
              <template slot="title">研学团队</template>
              <el-menu-item index="/mentorlist">研学指导师</el-menu-item>
              <el-menu-item index="/expertlist">专家团队</el-menu-item>
            </el-submenu>
            <el-menu-item index="/OrgRegister">入驻平台</el-menu-item>
            <!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
          </el-menu>
        </div>
      </div>
    </div>
<!--    <div class="swim_box" v-if="screenWidth>785">-->
<!--      <div class="swim_title">-->
<!--        小程序查看-->
<!--      </div>-->
<!--      <div class="swim_code">-->
<!--        <img :src="coursedata.sun_code" alt="" srcset="">-->
<!--      </div>-->
<!--    </div>-->
    <div class="main_box" :style="screenWidth>785?'':'width:100%;'">
      <div class="camp_item" :style="screenWidth>785?'':'width:calc(100% - 30px);padding:15px;'">
        <div class="moduletitle" :style="screenWidth>785?'':'font-size:18px;'">
          <span class="actblock" :style="screenWidth>785?'':'height:30px;'"></span>保险信息
        </div>

        <div>
          <el-dialog title="使用微信扫一扫该二维码继续付款" :visible.sync="dialogVisible" width="30%" center>
            <img :src="payOrderUrl" alt="使用微信扫一扫该二维码继续付款" style="width: 180px; height: 180px; display: block; margin: 0 auto;"/>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">关 闭</el-button>
          </span>
          </el-dialog>
        </div>

        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <!-- 承保单位 -->
          <el-form-item label="承保单位">
            中国人民财产保险股份有限公司
          </el-form-item>
          <!-- 保险类型 -->
          <el-form-item label="保险类型" prop="insuranceTypeVal">
            <el-radio-group v-model="ruleForm.insuranceTypeVal" size="medium">
              <el-radio border label="1">个人投保</el-radio>
              <el-radio border label="2">团队投保</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 保险天数 -->
          <el-form-item label="保险天数" prop="insuranceDaysVal">
            <el-radio-group v-model="ruleForm.insuranceDaysVal" size="medium">
              <el-radio-button label="54">1天</el-radio-button>
              <el-radio-button label="55">2~3天</el-radio-button>
              <el-radio-button label="56">4~7天</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <!-- 被保险人身份 -->
          <el-form-item label-width="130px" label="被保险人身份" prop="insuranceRoleVal" v-if="ruleForm.insuranceTypeVal === '1' ">
            <el-radio-group v-model="ruleForm.insuranceRoleVal" size="medium">
              <el-radio-button label="1">学生</el-radio-button>
              <el-radio-button label="2">成人</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <!-- 保险方案 -->
          <el-form-item label-width="130px" label="保险开始日期" >
            <el-col :span="11">
              <el-form-item prop="startDate">
                <el-date-picker type="date" placeholder="选择保险开始日期" :picker-options="ruleForm.pickerOptions" v-model="ruleForm.startDate" style="width: 100%;"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <!-- 保险方案 -->
          <el-form-item label="保险方案" prop="insuranceSchemeVal" >
            <el-radio-group v-model="ruleForm.insuranceSchemeVal" size="medium">
              <el-radio border label="1">低档方案</el-radio>
              <el-radio border label="2">高档方案</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 保险方案查看 -->
          <el-form-item label="保险方案">
            <el-button type="success" @click="showIframe = true" plain>查看保险方案</el-button>
            <el-button type="info" @click="showIframe = false" v-if="showIframe">隐藏保险方案</el-button>
          </el-form-item>
          <el-form-item label="">
            <iframe v-if="showIframe" :src="iframeSrc" width="800" height="600" frameborder="0" allowfullscreen></iframe>
          </el-form-item>
          <!-- 团队证件信息表单-s -->
          <!-- 单位信息 -->
          <div class="moduletitle" :style="screenWidth>785?'':'font-size:18px;'" v-if="ruleForm.insuranceTypeVal === '2'">
            <span class="actblock" :style="screenWidth>785?'':'height:30px;'"></span>单位信息
          </div>
          <div v-if="ruleForm.insuranceTypeVal === '2'">
            <el-form-item label-width="85px" label="备注：" style="color: red;">
              如果想申请发票，单位名称请与申请发票抬头一致
            </el-form-item>
            <!-- 一键导入历史单位信息 -->
            <el-form-item label-width="35px" label="" style="color: red;">
                <el-dropdown @command="selectOrgInfo">
                  <el-button type="warning">
                    一键导入历史单位信息<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="item in historyOrgList" :command="item">{{ item.name }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
            </el-form-item>
            <!-- 单位名称 -->
            <el-form-item label-width="100px" label="单位名称" prop="insured_name" >
              <el-col :span="6">
                <el-input placeholder="请输入单位名称" v-model="ruleForm.insured_name"></el-input>
              </el-col>
<!--              <el-col :span="6">-->
<!--                <el-button type="warning" @click="historyOrgList()" plain>一键导入历史单位信息<i class="el-icon-upload2"></i></el-button>-->
<!--              </el-col>-->
            </el-form-item>
            <!-- 单位性质 -->
            <el-form-item label-width="100px" label="单位性质" prop="org_nature" >
              <el-col :span="3">
                <el-select v-model="ruleForm.org_nature" placeholder="选择单位性质">
                  <el-option v-for="item in ruleForm.orgNatureData" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <!-- 统一社会信用代码 -->
            <el-form-item label-width="155px" label="统一社会信用代码" prop="org_code" >
              <el-col :span="6">
                <el-input placeholder="请输入统一社会信用代码" v-model="ruleForm.org_code"></el-input>
              </el-col>
            </el-form-item>
            <!-- 联系人姓名 -->
            <el-form-item label-width="110px" label="联系人姓名" prop="contact_name" >
              <el-col :span="5">
                <el-input placeholder="请输入联系人姓名" v-model="ruleForm.contact_name"></el-input>
              </el-col>
            </el-form-item>
            <!-- 联系人手机号 -->
            <el-form-item label-width="125px" label="联系人手机号" prop="contact_phone" >
              <el-col :span="5">
                <el-input placeholder="请输入联系人手机号" v-model="ruleForm.contact_phone"></el-input>
              </el-col>
            </el-form-item>

            <div class="moduletitle" :style="screenWidth>785?'':'font-size:18px;'">
              <span class="actblock" :style="screenWidth>785?'':'height:30px;'"></span>教师与学生数据导入&nbsp;&nbsp;<span style="color: red;">教师：{{ ruleForm.insurance_total_teacher }}人 学生：{{ ruleForm.insurance_total_student }}人</span>
            </div>
            <!-- 模版下载 -->
            <el-form-item label-width="100px" label="模版下载" prop="insured_name">
              <el-col :span="5">
                <el-button type="success" @click="downloadExcel(0)" plain>点击下载团队教师身份模版<i class="el-icon-download"></i></el-button>
              </el-col>
              <el-col :span="7">
                <el-button type="primary" @click="downloadExcel(1)" plain>点击下载学生及监护人模版<i class="el-icon-download"></i></el-button>
              </el-col>
            </el-form-item>
            <!-- 数据导入 -->
            <el-form-item label-width="100px" label="数据导入" prop="insured_name">
              <el-col :span="5">
                <el-upload
                    class="upload-demo"
                    action=""
                    accept=".xlsx, .XLSX, .xlsx, .XLSX"
                    :before-upload="uploadTeamExcelToCloud"
                    :http-request="uploadTeacher"
                    :limit="maxCountTeacher"
                    :on-exceed="handleExceedTeacher"
                    :on-remove="beforeRemoveTeacher"
                    :file-list="fileListTeacher">
                  <el-button type="success">点击上传团队教师身份信息<i class="el-icon-upload2"></i></el-button>
                </el-upload>
              </el-col>
              <el-col :span="7">
                <el-upload
                    class="upload-demo"
                    action=""
                    accept=".xlsx, .XLSX, .xlsx, .XLSX"
                    :before-upload="uploadTeamExcelToCloud"
                    :http-request="uploadStudent"
                    :limit="maxCountStudent"
                    :on-exceed="handleExceedStudent"
                    :on-remove="beforeRemoveStudent"
                    :file-list="fileListStudent">
                  <el-button type="primary">点击上传学生及监护人信息<i class="el-icon-upload2"></i></el-button>
                </el-upload>
              </el-col>
            </el-form-item>
          </div>
          <!-- 团队证件信息表单-e -->

          <!-- 个人证件信息表单-->
          <div v-if="ruleForm.insuranceTypeVal === '1'">
            <!-- 投保人信息 -->
            <div class="moduletitle" :style="screenWidth>785?'':'font-size:18px;'">
              <span class="actblock" :style="screenWidth>785?'':'height:30px;'"></span>投保人信息
            </div>
            <!-- 投保人姓名 -->
            <el-form-item label-width="113px" label="投保人姓名" prop="insured_name" >
              <el-col :span="5">
                <el-input placeholder="请输入投保人姓名" v-model="ruleForm.insured_name"></el-input>
              </el-col>
            </el-form-item>
            <!-- 联系人手机号 -->
            <el-form-item label-width="125px" label="联系人手机号" prop="contact_phone" >
              <el-col :span="5">
                <el-input placeholder="请输入联系人手机号" v-model="ruleForm.contact_phone"></el-input>
              </el-col>
            </el-form-item>
            <!-- 投保人身份证号 -->
            <el-form-item label-width="140px" label="投保人身份证号" prop="insured_card" >
              <el-col :span="5">
                <el-input placeholder="请输入投保人身份证号" v-model="ruleForm.insured_card"></el-input>
              </el-col>
            </el-form-item>

            <!-- 被投保人信息 -->
            <div class="moduletitle" :style="screenWidth>785?'':'font-size:18px;'">
              <span class="actblock" :style="screenWidth>785?'':'height:30px;'"></span>被投保人信息
            </div>
            <!-- 被保险人姓名 -->
            <el-form-item label-width="125px" label="被保险人姓名" prop="insurant_name" >
              <el-col :span="5">
                <el-input placeholder="请输入被保险人姓名" v-model="ruleForm.insurant_name"></el-input>
              </el-col>
            </el-form-item>
            <!-- 被保险人身份证号 -->
            <el-form-item label-width="153px" label="被保险人身份证号" prop="insurant_card" >
              <el-col :span="5">
                <el-input placeholder="请输入被保险人身份证号" v-model="ruleForm.insurant_card"></el-input>
              </el-col>
            </el-form-item>
          </div>
          <el-form-item label="">
            <iframe v-if="showIframe2" :src="iframeSrc2" width="800" height="600" frameborder="0" allowfullscreen></iframe>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">提交投保数据</el-button>
<!--            <el-button @click="resetForm('ruleForm')">重置</el-button>-->
          </el-form-item>
        </el-form>

      </div>

<!--      <div class="coursemain_box">-->
<!--        <el-tabs v-model="activeName" type="card">-->
<!--          <el-tab-pane v-for="(item, index) in coursedata.arr" :key="item" :label="item.title" :name="index">-->
<!--            <div class="coursemain_richitem" v-for="rich in item.content" :key="rich">-->
<!--              <div class="rich_title" style="margin-bottom: 10px;">-->
<!--                <span class="richblock"></span>{{ rich.title }}-->
<!--              </div>-->
<!--              <div class="richbox" v-html="rich.content"></div>-->
<!--            </div>-->
<!--          </el-tab-pane>-->
<!--        </el-tabs>-->
<!--      </div>-->
    </div>
    <div :class="tops?'navbar':'navbar-top'" v-if="screenWidth>785">
      <el-tooltip class="item" effect="dark" content="返回首页" placement="left">
        <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @click="gohome()"><i
            class="el-icon-s-home"></i>
          <div style="font-size: 14px;">首页</div>
        </a>
      </el-tooltip>
      <div class="qrShow3 right2" v-if="showofficialQR">
        <img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;"/>
      </div>
      <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showofficialQRCode" @mouseleave="hideofficialQRCode"><i class="el-icon-s-help"></i>
        <div style="font-size: 14px;">公众号</div>
      </a>
      <div class="qrShow2 right2" v-if="showserviceQR">
        <img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;"/>
      </div>
      <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>
        <div style="font-size: 14px;">客服</div>
      </a>
      <div class="qrShow right" v-if="showQR">
        <img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;"/>
      </div>
      <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showQRCode" @mouseleave="hideQRCode"><i class="el-icon-mobile-phone"></i>
        <div style="font-size: 14px;">手机端</div>
      </a>
      <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
        <a @click="gotop"><i class="el-icon-caret-top"></i>
          <br>
          <span>顶部</span></a>
      </el-tooltip>
    </div>
    <!-- footer -->
    <div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;'" >
			<div class="subtexts" v-if="screenWidth>785" >
				<div v-for="(item, key) in bottomnav" :key="key" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
			</div>
			<div class="subnavbox" v-if="screenWidth<785" >
				<div class="subtext_title">
					关于研学平台
				</div>
				<div class="subtexts" :style="screenWidth>785?'':'width:calc(100% - 40px);flex-wrap:wrap;padding:20px;margin-top: 0px;'" >
					<div v-for="(item, key) in bottomnav" :key="key" :style="screenWidth>785?'':'width:25%;text-align: left;margin-bottom:15px'"  @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				</div>
			</div>
		<div class="footer_box">
			<div class="row"  :style="screenWidth>785?'padding-bottom:0px':'width:calc(100% - 20px);padding:0px 10px;padding-bottom:0px'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						指导单位：河南省教育厅   主办单位：河南省研学旅行教育协会
					</div>
				</div>
				
			</div>
			<div class="row"  :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div>
		</div>
  </div>
</template>

<script>
import {getNewslist, getPac, getCourselist, checktoken, getPc, getbottomnav, regettoken, handleUploadExcel, getTempKeys, checkUpload,getHistoryOrgList,createPiccOrder,getPayOrderUrl,checkPiccData} from '@/request/api'
import COS from "cos-js-sdk-v5";

export default {
  name: "CourseDetails",
  // components: {
  //   navTab
  // },
  data() {
    return {
      payOrderUrl: '',
      dialogVisible: false,
      subData: [],
      showIframe: false,
      iframeSrc: 'https://pinsure.zhongyuanib.com/h5/salesPlatformMobile/travel/#/main?p=yanxue&isFooter=0',
      showIframe2: false,
      iframeSrc2: 'https://pinsure.zhongyuanib.com/h5/salesPlatformMobile/travel/#/main?p=yanxue&isFooter=1',
      historyOrgVal: '',
      historyOrgList: [],
      uploadType: '',
      bucket: 'yxwy-1254115215',
      region: 'ap-beijing',
      maxCountTeacher: 1,
      maxCountStudent: 1,
      fileListTeacher: [],
      fileListStudent: [],
      houzhui: '.xlsx',
      ruleForm: {
        // 保险类型
        insuranceTypeVal: '1',
        // 保险方案
        insuranceSchemeVal: '',
        // 保险天数
        insuranceDaysVal: '54',
        insuranceRoleVal: '1',
        insurant_role: '1',
        insured_name: '',
        org_code: '',
        contact_name: '',
        contact_phone: '',
        insured_card: '',
        insurant_name: '',
        insurant_card: '',
        excel_teacher_data: [],
        excel_student_data: [],
        insurance_total_teacher: 0,
        insurance_total_student: 0,
        piccFile: "",
        activityTemplate: [],
        insuranceNatureData: [
          {
            value: 1,
            name: '保险1天',
          },
          {
            value: 2,
            name: '保险2~3天',
          },
          {
            value: 3,
            name: '保险4~7天',
          }
        ],
        insuranceSchemeData: [],
        org_nature: '',
        org_nature_value: 0,
        orgNatureShow: false,
        orgNatureData: [{
          value: 300,
          label: '企业单位'
        }, {
          value: 200,
          label: '事业单位'
        }, {
          value: 240,
          label: '教育事业'
        }, {
          value: 330,
          label: '个体'
        }, {
          value: 900,
          label: '其他'
        }],
        orgListShow: false,
        orgListData: [],
        startDate: '',
        pickerOptions: {
          disabledDate(time) {
            //选择今天以及今天之后的日期
            return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择
          }
        },
      },
      /*rules: {
        insuranceTypeVal: [
          { required: true, message: '请选择保险类型', trigger: 'change' }
        ],
        insuranceDaysVal: [
          { required: true, message: '请选择保险天数', trigger: 'change' }
        ],
        insuranceRoleVal: [
          { required: true, message: '请选择被保险人身份', trigger: 'change' }
        ],
        insuranceSchemeVal: [
          { required: true, message: '请选择保险方案', trigger: 'change' }
        ],
        startDate: [
          { type: 'date', required: true, message: '请选择保险开始日期', trigger: 'change' }
        ],
        insured_name: [
          { required: true, message: '不能为空', trigger: 'blur' },
        ],
        org_nature: [
          { required: true, message: '请选择单位性质', trigger: 'change' }
        ],
        org_code: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
        ],
        contact_name: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' },
        ],
        contact_phone: [
          { required: true, message: '请输入联系人手机号', trigger: 'blur' },
        ],
        insured_card: [
          { required: true, message: '请输入投保人身份证号', trigger: 'blur' },
        ],
        insurant_name: [
          { required: true, message: '请输入被保险人姓名', trigger: 'blur' },
        ],
        insurant_card: [
          { required: true, message: '请输入被保险人身份证号', trigger: 'blur' },
        ],
      },*/

      bottomnav: [],
      //搜索相关
      top_search_url: '/Siteall',
      options: [
        {
          value: '/Siteall',
          label: '全站搜索'
        }, {
          value: '/Camplist',
          label: '营地搜索'
        }, {
          value: '/Baselist',
          label: '基地搜索'
        }, {
          value: '/Courselist',
          label: '课程搜索'
        }, {
          value: '/Newslist',
          label: '资讯搜索'
        },
        {
          value: '/Activitylist',
          label: '活动搜索'
        },
        {
          value: '/Linelist',
          label: '线路搜索'
        },
        {
          value: '/traveler',
          label: '机构搜索'
        }, {
          value: '/mentorlist',
          label: '指导师搜索'
        },],
      //搜索相关
      manage_url: '',
      manageoptions: [
        {
          value: 'http://qianjin.wanjiaxiao.cn/',
          label: '研学报备'
        }, {
          value: 'https://admin.henanyanxue.com/',
          label: '管理入口'
        },
       
      ],
      activeIndex2: '/CourseDetails',
      phoneboxshow: false,
      userInfo: {
        username: "",
        education_name: "",
        role_level: ""
      },
      logintype: true,
      banner: [],
      camptypes: [
        {text: '全部', value: 0},
        {text: '基地', value: 2},
        {text: '营地', value: 1},
      ],
      categorytypes: [],
      camptype: 0,
      camplist: [],
      quicklist: [],
      aclist: [],
      newsiconon: '',
      category_id: 0,
      period: 0,
      total: 0,
      page_index: 1,
      uuid: '',
      coursedata: {},
      activeName: 0,
      pcsetdata: {},
      //侧边栏
      showQR: false,
      showserviceQR: false,
      showofficialQR: false,
      tops: false,
      heights: window.innerHeight,
      scrolltop: '',
      //屏幕宽高
      // 屏幕宽度
      screenWidth: window.innerWidth,
      top_bannerWidth: Math.round(window.innerWidth / 3.42),
      // 屏幕高度
      screenHeight: window.innerHeight,
      //手机端导航栏
      vannavshow: false,
      vannavlist: [
        {
          link: '/Home',
          text: '研学首页'
        },
        {
          link: '/Camplist',
          text: '营地列表'
        },
        {
          link: '/Newslist',
          text: '资讯资讯'
        },
        {
          link: '/Baselist',
          text: '基地列表'
        },
        {
          link: '/Courselist',
          text: '研学课程'
        },
        {
          link: '/Activitylist',
          text: '研学活动'
        },
        {
          link: '/Linelist',
          text: '研学线路'
        },
        {
          link: '/traveler',
          text: '研学机构'
        },
        {
          link: '/mentorlist',
          text: '研学指导师'
        },
        {
          link: '/expertlist',
          text: '专家团队'
        },
        {
          link: '/OrgRegister',
          text: '入驻平台'
        },
      ],
    }
  },
  beforeCreate() {
    const loading = this.$loading({
      lock: true,
      text: '页面载入……',
      // spinner: 'el-icon-loading',
      background: '#ffffff'
    });
  },
  created() {
    this.getpcset()
  },
  mounted() {
    const {id} = this.$route.query;
    window.addEventListener('resize', this.handleResize, true)

    this.uuid = 1027
    let token = localStorage.getItem('token') || ''
    if (!token) {
      this.gologin()
      return
    }
    this.token = token
    this.selectHistoryOrgList()
    this.getbottomnav()
    this.getDetails()
    console.log("到这了");
    // this.gettypes()

    window.addEventListener('scroll', this.scrollToTop)
    // 监听保险协议返回值方法
    window.addEventListener("message", this.receiveMessage, false);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  // 销毁监听
  beforeDestroy() {
    window.removeEventListener("message", this.receiveMessage);
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    /**
     * 接收保险协议H5返回状态
     * @param event
     */
    receiveMessage(event) {
      let that = this;
      // 协议H5点击同意了保障
      if (event.data.type === 'insuranceConfirm') {
        console.log('保险协议页返回参数：', '点击了确认');
        that.showIframe2 = false;
        // 验证登录
        let token = localStorage.getItem('token') || ''
        if (!token) {
          this.gologin()
          return
        }
        let data = {}
        checktoken(data).then(res => {
          if (res.data.code === 201) {
            console.log(res)
            regettoken(data).then(res => {
              localStorage.setItem('token', res.data.data.token)
              localStorage.setItem('refreshToken', res.data.data.refreshToken)
            })
          }
        })
        // 继续请求接口生成支付订单
        createPiccOrder(that.subData).then(res => {
          if (res.data.code === 200) {

            getPayOrderUrl({orderId: res.data.data.orderid}).then(res => {
              if (res.data.code === 200) {
                // 生成订单成功后弹出跳转小程序支付订单页的二维码图
                that.payOrderUrl = res.data.data.payOrderUrl;
                that.dialogVisible = true;
              } else {
                that.$message({
                  message: res.data.msg,
                  type: 'warning'
                });
              }
            })

          }else{
            that.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        })
      }
      // 协议H5点击了放弃保障
      if (event.data.type === 'insuranceCancel') {
        console.log('保险协议页返回参数：', '点击了放弃');
        that.showIframe2 = false;
      }
    },
    // 选择的历史单位信息数据
    selectOrgInfo(orgInfo) {
      this.ruleForm.insured_name = orgInfo.name;
      this.ruleForm.org_nature = orgInfo.org_nature;
      this.ruleForm.org_code = orgInfo.org_code;
      this.ruleForm.contact_name = orgInfo.contact_name;
      this.ruleForm.contact_phone = orgInfo.contact_phone;
    },
    // 获取当前用户历史填过的单位列表
    selectHistoryOrgList() {
      let that = this;
      let token = localStorage.getItem('token') || ''
      if (!token) {
        this.gologin()
        return
      }
      let data = {}
      checktoken(data).then(res => {
        if (res.data.code === 201) {
          console.log(res)
          regettoken(data).then(res => {
            localStorage.setItem('token', res.data.data.token)
            localStorage.setItem('refreshToken', res.data.data.refreshToken)
          })
        }
      })
      getHistoryOrgList({}).then(res => {
        if (res.data.code === 200) {
          that.historyOrgList = res.data.data.data;
        }else{
          that.$message({
            message: '获取单位信息失败！',
            type: 'warning'
          });
        }
      })
    },
    // 上传至cos上
    uploadTeamExcelToCloud(file) {
      let token = localStorage.getItem('token') || ''
      if(!token){
        this.gologin()
        return false;
      }
      console.log('susu111',file)
    },
    // 上传团队教师Excel数据
    uploadTeacher(params) {
      console.log('susu2222', params);
      // 上传到腾讯云服务器 SDK(语法)
      let fileListTeacher = this.fileListTeacher;
      let timeStart = Date.now();
      let imagename = 'yanxuequan' + timeStart;
      let cos = new COS({
        getAuthorization: function (options, callback) {
          // 初始化时不会调用，只有调用 cos 方法（例如 cos.putObject）时才会进入
          // 异步获取临时密钥
          let data = options.Scope
          console.log(options.Scope)
          getTempKeys(data).then(res => {
            let data = res.data.data;
            console.log('data', data);
            let credentials = data && data.credentials;
            console.log('credentials', credentials);
            if (!data || !credentials) return console.error('credentials invalid');
            callback({
              TmpSecretId: credentials.tmpSecretId,        // 临时密钥的 tmpSecretId
              TmpSecretKey: credentials.tmpSecretKey,      // 临时密钥的 tmpSecretKey
              SecurityToken: credentials.sessionToken, // 临时密钥的 sessionToken
              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
              StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
              ExpiredTime: data.expiredTime, // 临时密钥失效时间戳，是申请临时密钥时，时间戳加 durationSeconds
              ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
            });
          })
        }
      });
      let filePathName = '/handsign/group/' + imagename + this.houzhui;
      cos.putObject(
          {
            Bucket: this.bucket /* 填入您自己的存储桶，必须字段 */,
            Region: this.region /* 存储桶所在地域，例如ap-beijing，必须字段 */,
            Key: filePathName /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
            Body: params.file /* 必须，上传文件对象，可以是input[type="file"]标签选择本地文件后得到的file对象 */,
            onProgress: function (progressData) {
              console.log(JSON.stringify(progressData));
            },
          },
          (err, data) => {
            console.log(err || data);
            if (data) {
              // 通知父亲
              console.log('data',data)
              fileListTeacher.push({...params.file, url: 'http://' + data.Location, name: imagename + this.houzhui});
              this.fileListTeacher = fileListTeacher
              console.log(this.fileListTeacher)
              let that = this;
              // 处理上传的excel模版数据,校验数据格式是否正确
              handleUploadExcel({uploadType: 1, filePathName: filePathName}).then(res => {
                  if (res.data.code === 200) {
                      // 教师导入 设置团队总人数、老师总人数
                      that.ruleForm.excel_teacher_data = res.data.data.data;
                      that.ruleForm.insurance_total_teacher = res.data.data.count;
                      // 继续处理添加文件数据流程
                      checkUpload({title: filePathName}).then(fileRes => {
                        if (fileRes.data.code === 200) {
                          that.$message({
                            message: '上传成功',
                            type: 'success'
                          });
                        }else{
                          that.$message({
                            message: fileRes.data.msg,
                            type: 'warning'
                          });
                        }
                      })
                  } else {
                    that.$alert(res.data.msg, '团队教师模版导入数据信息错误', {
                      confirmButtonText: '确定',
                      callback: action => {}
                    });
                  }
                })
            }
          }
      );
    },
    // 上传团队学生Excel数据
    uploadStudent(params) {
      console.log('susu2222', params);
      // 上传到腾讯云服务器 SDK(语法)
      let fileListStudent = this.fileListStudent;
      let timeStart = Date.now();
      let imagename = 'yanxuequan' + timeStart;
      let cos = new COS({
        getAuthorization: function (options, callback) {
          // 初始化时不会调用，只有调用 cos 方法（例如 cos.putObject）时才会进入
          // 异步获取临时密钥
          let data = options.Scope
          console.log(options.Scope)
          getTempKeys(data).then(res => {
            let data = res.data.data;
            console.log('data', data);
            let credentials = data && data.credentials;
            console.log('credentials', credentials);
            if (!data || !credentials) return console.error('credentials invalid');
            callback({
              TmpSecretId: credentials.tmpSecretId,        // 临时密钥的 tmpSecretId
              TmpSecretKey: credentials.tmpSecretKey,      // 临时密钥的 tmpSecretKey
              SecurityToken: credentials.sessionToken, // 临时密钥的 sessionToken
              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
              StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
              ExpiredTime: data.expiredTime, // 临时密钥失效时间戳，是申请临时密钥时，时间戳加 durationSeconds
              ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
            });
          })
        }
      });
      let filePathName = '/handsign/group/' + imagename + this.houzhui;
      cos.putObject(
          {
            Bucket: this.bucket /* 填入您自己的存储桶，必须字段 */,
            Region: this.region /* 存储桶所在地域，例如ap-beijing，必须字段 */,
            Key: filePathName /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
            Body: params.file /* 必须，上传文件对象，可以是input[type="file"]标签选择本地文件后得到的file对象 */,
            onProgress: function (progressData) {
              console.log(JSON.stringify(progressData));
            },
          },
          (err, data) => {
            console.log(err || data);
            if (data) {
              // 通知父亲
              console.log('data',data)
              fileListStudent.push({...params.file, url: 'http://' + data.Location, name: imagename + this.houzhui});
              this.fileListStudent = fileListStudent
              console.log(this.fileListStudent)
              let that = this;
              // 处理上传的excel模版数据,校验数据格式是否正确
              handleUploadExcel({uploadType: 2, filePathName: filePathName}).then(res => {
                if (res.data.code === 200) {
                    // 学生监护人导入 设置团队总人数、学生总人数
                    that.ruleForm.excel_student_data = res.data.data.data;
                    that.ruleForm.insurance_total_student = res.data.data.count;
                    // 继续处理添加文件数据流程
                    checkUpload({title: filePathName}).then(fileRes => {
                      if (fileRes.data.code === 200) {
                        that.$message({
                          message: '上传成功',
                          type: 'success'
                        });
                      }else{
                        that.$message({
                          message: fileRes.data.msg,
                          type: 'warning'
                        });
                      }
                    })
                } else {
                  that.$alert(res.data.msg, '学生及监护人模版导入数据信息错误', {
                    confirmButtonText: '确定',
                    callback: action => {}
                  });
                }
              })
            }
          }
      );
    },
    handleExceedTeacher(files, fileListTeacher) {
      this.$message.warning(`请先删除导入按钮下方的文件，再重新上传`);
    },
    handleExceedStudent(files, fileListStudent) {
      this.$message.warning(`请先删除导入按钮下方的文件，再重新上传`);
    },
    // 删除教师上传的Excel文件
    beforeRemoveTeacher(file, fileListTeacher) {
      console.log('shanchu',file, this.fileListTeacher,fileListTeacher)
      // return
      let that = this
      let cos = new COS({
        getAuthorization: function (options, callback) {
          // 初始化时不会调用，只有调用 cos 方法（例如 cos.putObject）时才会进入
          // 异步获取临时密钥
          let data = options.Scope
          console.log(options.Scope)
          getTempKeys(data).then(res => {
            let data = res.data.data;
            console.log('data', data);
            let credentials = data && data.credentials;
            console.log('credentials', credentials);
            if (!data || !credentials) return console.error('credentials invalid');
            callback({
              TmpSecretId: credentials.tmpSecretId,        // 临时密钥的 tmpSecretId
              TmpSecretKey: credentials.tmpSecretKey,      // 临时密钥的 tmpSecretKey
              SecurityToken: credentials.sessionToken, // 临时密钥的 sessionToken
              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
              StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
              ExpiredTime: data.expiredTime, // 临时密钥失效时间戳，是申请临时密钥时，时间戳加 durationSeconds
              ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
            });
          })
        }
      });
      cos.deleteObject({
        Bucket: this.bucket /* 填入您自己的存储桶，必须字段 */,
        Region: this.region /* 存储桶所在地域，例如ap-beijing，必须字段 */,
        Key: '/handsign/group/' + file.name, /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
      }, function(err, data) {
        console.log(err || data);
        if (fileListTeacher.length === 0) that.maxCountTeacher = 1
        that.fileListTeacher = fileListTeacher
        // 设置默认值
        that.ruleForm.excel_teacher_data = [];
        that.ruleForm.insurance_total_teacher = 0;
        console.log('删除成功')
        that.$message({
          message: '删除成功',
          type: 'success'
        });
      });
    },
    // 删除学生上传的Excel文件
    beforeRemoveStudent(file, fileListStudent) {
      console.log('shanchu',file, this.fileListStudent,fileListStudent)
      // return
      let that = this
      let cos = new COS({
        getAuthorization: function (options, callback) {
          // 初始化时不会调用，只有调用 cos 方法（例如 cos.putObject）时才会进入
          // 异步获取临时密钥
          let data = options.Scope
          console.log(options.Scope)
          getTempKeys(data).then(res => {
            let data = res.data.data;
            console.log('data', data);
            let credentials = data && data.credentials;
            console.log('credentials', credentials);
            if (!data || !credentials) return console.error('credentials invalid');
            callback({
              TmpSecretId: credentials.tmpSecretId,        // 临时密钥的 tmpSecretId
              TmpSecretKey: credentials.tmpSecretKey,      // 临时密钥的 tmpSecretKey
              SecurityToken: credentials.sessionToken, // 临时密钥的 sessionToken
              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
              StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
              ExpiredTime: data.expiredTime, // 临时密钥失效时间戳，是申请临时密钥时，时间戳加 durationSeconds
              ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
            });
          })
        }
      });
      cos.deleteObject({
        Bucket: this.bucket /* 填入您自己的存储桶，必须字段 */,
        Region: this.region /* 存储桶所在地域，例如ap-beijing，必须字段 */,
        Key: '/handsign/group/' + file.name, /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
      }, function(err, data) {
        console.log(err || data);
        if (fileListStudent.length === 0) that.maxCountStudent = 1
        that.fileListStudent = fileListStudent
        // 设置默认值
        that.ruleForm.excel_student_data = [];
        that.ruleForm.insurance_total_student = 0;
        console.log('删除成功')
        that.$message({
          message: '删除成功',
          type: 'success'
        });
      });
    },
    // 下载身份信息excel模版
    downloadExcel(type) {
      const loading = this.$loading({
        lock: true,
        text: '下载模版中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const excelArray = [
          // 教师导入模版
          'https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/handsign/img/oTM3X5b2-Xh3KOv48Occ2jAQ4DJ01732244777271.xlsx',
          // 学生监护人导入模版
          'https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/handsign/img/oTM3X5b2-Xh3KOv48Occ2jAQ4DJ01732245264399.xlsx'
      ]
      const excelUrl = excelArray[type];
      // 创建一个临时的a标签
      const link = document.createElement('a');
      link.href = excelUrl;
      link.download = type === 0 ? '教师报名表（模版）' : '学生及监护人报名表（模版）' + '.xlsx';
      // 触发下载
      document.body.appendChild(link);
      link.click();
      // 移除临时的a标签
      document.body.removeChild(link);
      loading.close();
    },
    // 调整至登录页
    gologin() {
      this.$router.push({
        path: "/Login",
        name: "/Login",
        query: {}
      });
    },
    // 提交保险数据
    submitForm(formName) {
      let token = localStorage.getItem('token') || ''
      if (!token) {
        this.gologin()
        return
      }
      let data = {}
      checktoken(data).then(res => {
        if (res.data.code === 201) {
          console.log(res)
          regettoken(data).then(res => {
            localStorage.setItem('token', res.data.data.token)
            localStorage.setItem('refreshToken', res.data.data.refreshToken)
          })
        }
      })
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 保险日期必选
          if (this.ruleForm.startDate === '') {
            this.$message({
              showClose: true,
              message: '请选择保险开始日期',
              type: 'error'
            });
            return;
          }
          // 保险方案必选
          if (this.ruleForm.insuranceSchemeVal === '') {
            this.$message({
              showClose: true,
              message: '请选择保险方案',
              type: 'error'
            });
            return;
          }
          // 验证投保人姓名必填
          if (this.ruleForm.insured_name === null || this.ruleForm.insured_name.trim() === '') {
              this.$message({
                showClose: true,
                message: this.ruleForm.insuranceTypeVal === '2' ? '单位名称不能为空' : '投保人姓名不能为空',
                type: 'error'
              });
              return;
          }
          if (this.ruleForm.insuranceTypeVal === '2') {
            // 验证企业性质必选
            if (this.ruleForm.org_nature === '') {
                this.$message({
                  showClose: true,
                  message: '请选择单位性质',
                  type: 'error'
                });
                return;
            }
            // 验证单位名称必填
            if (this.ruleForm.org_code === null || this.ruleForm.org_code.trim() === '') {
                this.$message({
                  showClose: true,
                  message: '统一社会信用代码不能为空',
                  type: 'error'
                });
                return;
            }
            if (this.ruleForm.org_code.length !== 18 || !(/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]+$/.test(this.ruleForm.org_code))) {
                this.$message({
                  showClose: true,
                  message: '统一社会信用代码格式不正确，格式为18位数字与英文字母组成',
                  type: 'error'
                });
                return;
            }
            // 验证联系人姓名必填
            if (this.ruleForm.contact_name === null || this.ruleForm.contact_name.trim() === '') {
                this.$message({
                  showClose: true,
                  message: '联系人姓名不能为空',
                  type: 'error'
                });
                return;
            }
          }
          // 验证投保人联系方式必填
          if (!(/^1\d{10}$/.test(this.ruleForm.contact_phone))) {
              this.$message({
                showClose: true,
                message: '联系人手机号为空或格式错误',
                type: 'error'
              });
              return;
          }
          // 验证投保人姓名必填
          if (this.ruleForm.insuranceTypeVal === '1' && !(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.ruleForm.insured_card))) {
              this.$message({
                showClose: true,
                message: '投保人身份证号码不能为空或格式错误',
                type: 'error'
              });
              return;
          }
          if (this.ruleForm.insuranceTypeVal === '1' && !this.isIdCardNo(this.ruleForm.insured_card)) {
              this.$message({
                showClose: true,
                message: '投保人身份证号码不能为空或格式错误',
                type: 'error'
              });
              return;
          }
          // 只有保险类型为个人时验证
          if (this.ruleForm.insuranceTypeVal === '1') {
            // 验证被保险人姓名必填
            if (this.ruleForm.insurant_name === null || this.ruleForm.insurant_name.trim() === '') {
                this.$message({
                  showClose: true,
                  message: '被保险人姓名不能为空',
                  type: 'error'
                });
                return;
            }
            // 验证投保人姓名必填
            if (!(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.ruleForm.insurant_card))) {
                this.$message({
                  showClose: true,
                  message: '被保险人身份证号码不能为空或格式错误',
                  type: 'error'
                });
                return;
            }
            if (!this.isIdCardNo(this.ruleForm.insurant_card)) {
                this.$message({
                  showClose: true,
                  message: '被保险人身份证号码不能为空或格式错误',
                  type: 'error'
                });
                return;
            }
            // 当个人保险角色是学生时，校验被保人年龄需在3~40岁之间
            if (this.ruleForm.insuranceRoleVal === '1') {
              // 提取出生日期部分
              const birthDateStr = this.ruleForm.insurant_card.substring(6, 14);
              const year = parseInt(birthDateStr.substring(0, 4), 10);
              const month = parseInt(birthDateStr.substring(4, 6), 10);
              const day = parseInt(birthDateStr.substring(6, 8), 10);
              // 创建出生日期对象
              const birthDate = new Date(year, month - 1, day); // 月份在Date中是0-11，所以需要减1
              // 获取当前日期
              const today = new Date();
              // 计算年龄：当前年份减去出生年份
              let age = today.getFullYear() - birthDate.getFullYear()
              if (age < 3 || age > 40) {
                this.$message({
                  showClose: true,
                  message: '被保险人身份为学生时，年龄最小为3岁，最大为40岁，当前被保险人年龄为' + age,
                  type: 'error'
                });
                return;
              }
            }
          }
          // 只有保险类型为团队时验证
          if (this.ruleForm.insuranceTypeVal === '2') {
            // 验证团队教师模版数据必传
            if (this.ruleForm.excel_teacher_data.length === 0 && this.ruleForm.excel_student_data.length === 0) {
                this.$message({
                  showClose: true,
                  message: '团队教师与学生及监护人excel数据不能都为空',
                  type: 'error'
                });
                return;
            }
          }

          let that = this;
          // 整理提交的数据
          let subData = {
            // 保险信息
            insurance_type: that.ruleForm.insuranceTypeVal,
            insurance_days: that.ruleForm.insuranceDaysVal,
            insurance_scheme: that.ruleForm.insuranceSchemeVal,
            start_time: that.dateFormat(that.ruleForm.startDate),
            insurance_role: that.ruleForm.insuranceRoleVal,
            // 证件信息
            insured_name: that.ruleForm.insured_name,
            org_code: that.ruleForm.org_code,
            org_nature: that.ruleForm.org_nature,
            contact_name: that.ruleForm.contact_name,
            contact_phone: that.ruleForm.contact_phone,
            insured_card: that.ruleForm.insured_card,
            insurant_name: that.ruleForm.insurant_name,
            insurant_card: that.ruleForm.insurant_card,
            // 教师与学生数据导入信息
            excel_teacher_data: that.ruleForm.excel_teacher_data,
            excel_student_data: that.ruleForm.excel_student_data,
            insurance_total_teacher: that.ruleForm.insurance_total_teacher,
            insurance_total_student: that.ruleForm.insurance_total_student,
            openid: localStorage.getItem('token'),
            // 区分pc端提交保险类型
            isPc: true
          }
          // 提交数据前先校验数据是否已添加过，提示用户继续提交，或立即支付
          checkPiccData(subData).then(res => {
            if (res.data.data.code === 0) {
              that.$confirm('为保证投保成功，请您确认所填信息是否正确，点击确认后信息将无法修改', '确认信息', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                that.showIframe2 = true;
                that.subData = subData;
              }).catch(() => {});
            } else if (res.data.data.code === 1) {
              // 已存在待支付投保的订单，跳转待支付订单去支付
              that.$confirm(res.data.data.data.msg, '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                // 继续根据当前待支付订单生成二维码图片跳转到待支付投保单单页面
                getPayOrderUrl({orderId: res.data.data.data.order_id}).then(payUrlRes => {
                  if (payUrlRes.data.code === 200) {
                    // 生成订单成功后弹出跳转小程序支付订单页的二维码图
                    that.payOrderUrl = payUrlRes.data.data.payOrderUrl;
                    that.dialogVisible = true;
                  } else {
                    that.$message({
                      message: payUrlRes.data.msg,
                      type: 'warning'
                    });
                  }
                })

              }).catch(() => {});
            } else if (res.data.data.code === 2) {
              // 被保险人存在已投保成功数据，不允许继续投保
              that.$confirm(res.data.data.data.msg, '已存在投保成功订单', {
                confirmButtonText: '确认',
                type: 'warning'
              }).then(() => {}).catch(() => {});
            } else {
              that.$message({
                message: '未知错误，请联系管理员！',
                type: 'warning'
              });
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 重置保险数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 日期转换为正常格式
    dateFormat(time) {
      const date = new Date(time);
      return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0')
    },
    // 身份证号验证
    isIdCardNo(num) {
      if (isNaN(num)) {
        console.log("输入的不是数字！");
        return false;
      }
      var len = num.length, re;
      if (len === 15)
        re = new RegExp(/^(\d{6})()?(\d{2})(\d{2})(\d{2})(\d{3})$/);
      else if (len === 18)
        re = new RegExp(/^(\d{6})()?(\d{4})(\d{2})(\d{2})(\d{3})(\d)$/);
      else {
        console.log("输入的数字位数不对！");
        return false;
      }
      var a = num.match(re);
      if (a != null) {
        if (len === 15) {
          var D = new Date("19" + a[3] + "/" + a[4] + "/" + a[5]);
          var B = D.getYear() == a[3] && (D.getMonth() + 1) == a[4] && D.getDate() == a[5];
        } else {
          var D = new Date(a[3] + "/" + a[4] + "/" + a[5]);
          var B = D.getFullYear() == a[3] && (D.getMonth() + 1) == a[4] && D.getDate() == a[5];
        }
        if (!B) {
          console.log("输入的身份证号 " + a[0] + " 里出生日期不对！");
          return false;
        }
      }
      return true;
    },
    gotopsearch() {
      this.$router.push({
        path: this.top_search_url,
        name: this.top_search_url,
        query: {
          stitle: this.stitle,
        }
      });
    },
    manageurl(e) {
      console.log('Site', e)
      if (e != '/') {
        window.open(e)
      }
      //this.manage_url = '/'
      // window.location.href = e;

    },
    vanlinkgo(e) {
      console.log(e)
      this.$router.push({
        path: e.link,
        name: e.link,
        query: {}
      });
    },
    vannavmenushow() {
      this.vannavshow = false
    },
    handleResize() {
      this.top_bannerWidth = 0;
      this.screenWidth = window.innerWidth;
      this.top_bannerWidth = window.innerWidth / 3.42
      console.log('screenWidth', this.screenWidth, this.top_bannerWidth)
      this.screenHeight = window.innerHeight;
    },
    getbottomnav() {
      var data = {
        page_index: 1,
        page_size: 15
      }
      getbottomnav(data).then(res => {
        this.bottomnav = res.data.data.list
      })
    },
    gobottomnav(type, link) {
      if (type == 1) {
        this.$router.push({
          path: link
        });
      } else if (type == 2) {
        window.location.href = link;
      }
    },
    logout() {
      var that = this
      this.$confirm('是否确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$alert("已退出登录", '', {
          confirmButtonText: '确认',
          callback: action => {
            localStorage.setItem('token', '')
            localStorage.setItem('refreshToken', '')
            that.$router.go(0)
          }
        });
      }).catch(() => {

      });
    },
    showofficialQRCode() {
      this.showofficialQR = true
    },
    hideofficialQRCode() {//隐藏二维码
      this.showofficialQR = false
    },
    showserviceQRCode() {
      this.showserviceQR = true
    },
    hideserviceQRCode() {//隐藏二维码
      this.showserviceQR = false
    },
    showQRCode() {//显示二维码
      this.showQR = true
    },
    hideQRCode() {//隐藏二维码
      this.showQR = false
    },
    scrollToTop() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.scrolltop = scrollTop
      if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
        this.tops = true
      } else {
        this.tops = false
      }
    },
    gotop() {
      let timer = setInterval(() => {
        document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
        if (this.scrolltop === 0) {
          clearInterval(timer)
        }
      }, 15)
    },
    showphonebox() {
      this.phoneboxshow = true
    },
    closephonebox() {
      this.phoneboxshow = false
    },
    goregister(e) {
      this.$router.push({
        path: "/register",
        name: "/register",
        query: {}
      });
    },
    gomap(e) {
      this.$router.push({
        path: "/Campmap",
        name: "/Campmap",
        query: {
          latitude: e.latitude,
          longitude: e.longitude,
        }
      });
    },
    gohome(e) {
      this.$router.push({
        path: "/Home",
        name: "/Home",
        query: {}
      });
    },
    getpcset() {
      getPc().then(res => {
        this.pcsetdata = res.data.data
      })
    },
    camptypetab(val) {
      this.category_id = val
      this.getlist()
    },
    periodtab(val) {
      this.period = val
      this.getlist()
    },
    pagechange(val) {
      this.page_index = val
      this.getlist()
    },
    getDetails() {
      var data = {
        // type:this.camptype,
        uuid: this.uuid,
      }
      getCourselist(data).then(res => {
        console.log(res.data)
        this.coursedata = res.data.data
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        loading.close();
        // this.total=res.data.data.total
        // this.quicklist=res.data.data.list
      }).catch(error => {
        console.error(error);
      });
    },
    handleClick(e) {
      console.log(e, this.category_id)
      this._getNewslist()
    },
    onitemopen(index) {
      this.newsiconon = index
    },
    gettypes() {
      var data = {}
      getPac(data).then(res => {
        console.log(res.data)
        this.categorytypes = res.data.data.cat
        this.periodtypes = res.data.data.res
        // this.category_id=res.data.data.cat[0].id
        // this.getlist()
      }).catch(error => {
        console.error(error);
      });
    },
    /*
     * 查看详情
     * */
    gocampdetail(e) {
      this.$router.push({
        path: "/CampDetails",
        name: "CampDetails",
        query: {
          id: e
        }
      });
    },

  }
};
</script>

<style scoped>
.coursemain_richitem {
  padding-bottom: 50px;
}

.coursemain {
  padding: 5px 20px;
  font-size: 16px;
  line-height: 24px;
  text-indent: 2rem;
  text-align: left;
}

.el-tag--dark {
  border: 0px;
  margin: 0px 2px;
}

.camp_item {
  padding: 20px;
  margin-top: 20px;
  /* width: 1060px; */
  background: #ffffff;

}

.campmsg_box {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
}

.camp_img {
  width: 337.5px;
  height: 161px;
  margin-left: 30px;
}

.camp_img img {
  width: 100%;
  height: 100%;
}

.camp_msg {
  width: 660px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

}

.camp_title {
  font-size: 20px;
  font-weight: 600;
  text-align: left;
  padding: 20px 0px;
}

.camp_address {
  color: #1b9d57;
  padding-bottom: 20px;
  font-size: 16px;
  text-align: left;
}

.camp_phone {
  padding-bottom: 20px;
  color: #66b1ff;
  text-align: left;
}

.moduletitle {
  display: flex;
  align-items: center;
  font-size: 20px;
  margin-bottom: 10px;
}

.rich_title {
  padding: 20px;
  padding-bottom: 0px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
}

.richblock {
  width: 6px;
  height: 30px;
  margin-right: 20px;
  display: block;
  background: #1b9d57;
}

.coursemain_box {
  /* padding: 20px; */
  background: #ffffff;
  margin-top: 20px;
}

@media only screen and (max-width: 768px) {
  ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
    padding-right: 20px !important;
  }
}
</style>